<template>
  <div class="container">
    <div class="title">数据看板/运营看板/运营分析</div>
    <el-card class="box-card">
      <div>
        <div class="title-item mr20">
          <el-tag class="mr20 analysis-tag" size="large" type="danger">时效分析</el-tag>
        </div>
      </div>
      <div class="analysis-header">
        <div class="analysis-item">
          <div class="title-item">待派发</div>
          <div class="stats">
            <div class="stat-group">
              <div class="stat-value">{{ pendingDispatchStats.workOrderCount }}</div>
              <div class="stat-label">工单数</div>
            </div>
            <div class="stat-group">
              <div class="stat-value">{{ pendingDispatchStats.deviceCount }}</div>
              <div class="stat-label">涉及设备</div>
            </div>
          </div>
        </div>
        <div class="analysis-item">
          <div class="title-item">超时</div>
          <div class="stats">
            <div class="stat-group">
              <div class="stat-value">{{ overtimeStats.workOrderCount }}</div>
              <div class="stat-label">工单数</div>
            </div>
            <div class="stat-group">
              <div class="stat-value">{{ overtimeStats.deviceCount }}</div>
              <div class="stat-label">涉及设备</div>
            </div>
          </div>
        </div>
        <div class="analysis-item">
          <div class="title-item">质量问题</div>
          <div class="stats">
            <div class="stat-group">
              <div class="stat-value">{{ qualityIssueStats.workOrderCount }}</div>
              <div class="stat-label">工单数</div>
            </div>
            <div class="stat-group">
              <div class="stat-value">{{ qualityIssueStats.deviceCount }}</div>
              <div class="stat-label">涉及设备</div>
            </div>
          </div>
        </div>
      </div>

      <el-table :data="tableData" style="width: 100%; margin-top: 20px" border>
        <el-table-column prop="workOrderId" label="工单号"></el-table-column>
        <el-table-column prop="status" label="工单状态"></el-table-column>
        <el-table-column prop="type" label="工单类型"></el-table-column>
        <el-table-column prop="handler" label="当前处理人"></el-table-column>
        <el-table-column prop="stage" label="当前阶段"></el-table-column>
        <el-table-column prop="overtime" label="超时时间"></el-table-column>
      </el-table>
    </el-card>

    <el-card class="box-card">
      <div>
        <div class="title-item mr20">
          <el-tag class="mr20 analysis-tag" size="large" type="danger">人效分析</el-tag>
        </div>
      </div>
      <div class="analysis-content">
        <div class="data-section">
          <div class="section-title">服务器搬迁</div>
          <div class="section-subtitle">{{ serverRelocationPerPersonStats }}台/人天</div>
          <div class="data-list">
            <div class="data-item" v-for="(value, location) in serverRelocationStats" :key="location">
              <span class="location">{{ location }}</span>
              <span class="value">{{ value }}</span>
            </div>
          </div>
        </div>
        <div class="chart-section">
          <div class="bar-chart">
            <div class="bar" v-for="(value, location) in serverRelocationStats" :key="location"
                 :style="{ height: (value / Math.max(...Object.values(serverRelocationStats)) * 100) + '%' }">
              <div class="bar-value">{{ value }}</div>
              <div class="bar-label">{{ location }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="analysis-content">
        <div class="data-section">
          <div class="section-title">TPC部署</div>
          <div class="section-subtitle">{{ tpcDeploymentPerPersonStats }}台/人天</div>
          <div class="data-list">
            <div class="data-item" v-for="(value, location) in tpcDeploymentStats" :key="location">
              <span class="location">{{ location }}</span>
              <span class="value">{{ value }}</span>
            </div>
          </div>
        </div>
        <div class="chart-section">
          <div class="bar-chart">
            <div class="bar" v-for="(value, location) in tpcDeploymentStats" :key="location"
                 :style="{ height: (value / Math.max(...Object.values(tpcDeploymentStats)) * 100) + '%' }">
              <div class="bar-value">{{ value }}</div>
              <div class="bar-label">{{ location }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="analysis-content">
        <div class="data-section">
          <div class="section-title">网络特殊变更</div>
          <div class="section-subtitle">{{ networkChangePerPersonStats }}台/人天</div>
          <div class="data-list">
            <div class="data-item" v-for="(value, location) in networkChangeStats" :key="location">
              <span class="location">{{ location }}</span>
              <span class="value">{{ value }}</span>
            </div>
          </div>
        </div>
        <div class="chart-section">
          <div class="bar-chart">
            <div class="bar" v-for="(value, location) in networkChangeStats" :key="location"
                 :style="{ height: (value / Math.max(...Object.values(networkChangeStats)) * 100) + '%' }">
              <div class="bar-value">{{ value }}</div>
              <div class="bar-label">{{ location }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getPendingDispatchStatistics, getOvertimeStatistics, getQualityIssueStatistics, getServerRelocationStatistics, tpcDeploymentStatistics, getServerStatistics, getNetworkChangeStatistics, getTPCDeploymentPerPersonStatistics,getNetworkChangePerPersonStatistics } from '@/api/analysis';

export default {
  data() {
    return {
      tableData: [
        {
          workOrderId: 'WO2023001',
          status: '处理中',
          type: '维修',
          handler: '张工',
          stage: '评估',
          overtime: '2小时',
        },
        // 更多数据项...
      ],
      pendingDispatchStats: {
        workOrderCount: 0,
        deviceCount: 0,
      },
      overtimeStats: {
        workOrderCount: 0,
        deviceCount: 0,
      },
      qualityIssueStats: {
        workOrderCount: 0,
        deviceCount: 0,
      },
      serverRelocationStats: {
        '清远-清新': 0,
        '张家口-怀来东园': 0,
        '上海-临港': 0,
        '上海-书院': 0,
        '杭州-东冠': 0,
        '惠州-联丰': 0,
        '昆山-千灯': 0,
        '韶关-沐阳': 0
      },
      serverRelocationPerPersonStats: 0,
      tpcDeploymentStats: {
        '清远-清新': 0,
        '张家口-怀来东园': 0,
        '上海-临港': 0,
        '上海-书院': 0,
        '杭州-东冠': 0,
        '惠州-联丰': 0,
        '昆山-千灯': 0,
        '韶关-沐阳': 0
      },
      tpcDeploymentPerPersonStats: 0,
      networkChangeStats: {
        '清远-清新': 0,
        '张家口-怀来东园': 0,
        '上海-临港': 0,
        '上海-书院': 0,
        '杭州-东冠': 0,
        '惠州-联丰': 0,
        '昆山-千灯': 0,
        '韶关-沐阳': 0
      },
      networkChangePerPersonStats: 0,
    };
  },
  created() {
    this.fetchPendingDispatchStatistics();
    this.fetchOvertimeStatistics();
    this.fetchQualityIssueStatistics();
    this.fetchServerRelocationStatistics();
    this.fetchServerStatistics();
    this.fetchTPCDeploymentStatistics();
    this.fetchTPCDeploymentPerPersonStatistics();
    this.fetchNetworkChangeStatistics();
    this.fetchNetworkChangePerPersonStatistics();
  },
  methods: {
    async fetchPendingDispatchStatistics() {
      try {
        const { data } = await getPendingDispatchStatistics();
        this.pendingDispatchStats = {
          workOrderCount: data.data.order_count,
          deviceCount: data.data.device_count
        };
      } catch (error) {
        console.error('获取待派发工单统计数据失败:', error);
      }
    },
    async fetchOvertimeStatistics() {
      try {
        const { data } = await getOvertimeStatistics();
        this.overtimeStats = {
          workOrderCount: data.data.order_count,
          deviceCount: data.data.device_count
        };
      } catch (error) {
        console.error('获取超时工单统计数据失败:', error);
      }
    },
    async fetchQualityIssueStatistics() {
      try {
        const { data } = await getQualityIssueStatistics();
        this.qualityIssueStats = {
          workOrderCount: data.order_count,
          deviceCount: data.device_count
        };
      } catch (error) {
        console.error('获取质量问题工单统计数据失败:', error);
      }
    },
    async fetchServerRelocationStatistics() {
      try {
        const { data } = await getServerRelocationStatistics();
        const defaultLocations = {
          '清远-清新': 0,
          '张家口-怀来东园': 0,
          '上海-临港': 0,
          '上海-书院': 0,
          '杭州-东冠': 0,
          '惠州-联丰': 0,
          '昆山-千灯': 0,
          '韶关-沐阳': 0
        };
        data.data.campus_stats.forEach(item => {
          defaultLocations[item.campus] = parseInt(item.device_count);
        });
        this.serverRelocationStats = defaultLocations;
      } catch (error) {
        console.error('获取服务器搬迁统计数据失败:', error);
      }
    },
    async fetchServerStatistics() {
      try {
        const { data } = await getServerStatistics();
        this.serverRelocationPerPersonStats = data.data.daily_per_person;
      } catch (error) {
        console.error('获取服务器搬迁人均统计数据失败:', error);
      }
    },
    async fetchTPCDeploymentStatistics() {
      try {
        const { data } = await tpcDeploymentStatistics();
        const defaultLocations = {
          '清远-清新': 0,
          '张家口-怀来东园': 0,
          '上海-临港': 0,
          '上海-书院': 0,
          '杭州-东冠': 0,
          '惠州-联丰': 0,
          '昆山-千灯': 0,
          '韶关-沐阳': 0
        };
        data.data.campus_stats.forEach(item => {
          defaultLocations[item.campus] = parseInt(item.device_count);
        });
        this.tpcDeploymentStats = defaultLocations;
      } catch (error) {
        console.error('获取TPC部署统计数据失败:', error);
      }
    },
    async fetchTPCDeploymentPerPersonStatistics() {
      try {
        const { data } = await getTPCDeploymentPerPersonStatistics();
        this.tpcDeploymentPerPersonStats = data.data.daily_per_person;
      } catch (error) {
        console.error('获取TPC部署人均统计数据失败:', error);
      }
    },
    async fetchNetworkChangeStatistics() {
      try {
        const { data } = await getNetworkChangeStatistics();
        const defaultLocations = {
          '清远-清新': 0,
          '张家口-怀来东园': 0,
          '上海-临港': 0,
          '上海-书院': 0,
          '杭州-东冠': 0,
          '惠州-联丰': 0,
          '昆山-千灯': 0,
          '韶关-沐阳': 0
        };
        data.data.campus_stats.forEach(item => {
          defaultLocations[item.campus] = parseInt(item.device_count);
        });
        this.networkChangeStats = defaultLocations;
      } catch (error) {
        console.error('获取网络变更统计数据失败:', error);
      }
    },
    async fetchNetworkChangePerPersonStatistics() {
      try {
        const { data } = await getNetworkChangePerPersonStatistics();
        this.networkChangePerPersonStats = data.data.daily_per_person;
      } catch (error) {
        console.error('获取网络变更人均统计数据失败:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.box-card {
  margin-bottom: 20px;
}

.analysis-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px;
}

.analysis-item {
  flex: 1;
  background: #f5f7fa;
  border-radius: 8px;
  padding: 20px;
  margin: 0 10px;

  h3 {
    color: #303133;
    font-size: 18px;
    margin-bottom: 15px;
    font-weight: 600;
  }
}

.stats {
  display: flex;
  justify-content: space-around;
}

.stat-group {
  text-align: center;

  .stat-value {
    font-size: 24px;
    color: #409eff;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .stat-label {
    font-size: 14px;
    color: #606266;
  }
}

::v-deep .el-table {
  th {
    background-color: #f5f7fa;
    color: #303133;
  }

  td {
    color: #606266;
  }
}

.title-item {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
  text-align: center;
}

.mr20 {
  font-weight: bold;
  margin-bottom: 5px;
}

.analysis-tag {
  font-size: 1.2em;
  padding: 0.3em 1em;
  height: auto;
  line-height: 1.5;
}

.analysis-content {
  display: flex;
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.data-section {
  flex: 1;
  padding-right: 40px;
}

.section-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #606266;
  margin-bottom: 20px;
}

.data-list {
  .data-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px;
    background: white;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .location {
      font-size: 16px;
      color: #303133;
    }

    .value {
      font-size: 18px;
      font-weight: bold;
      color: #409eff;
    }
  }
}

.chart-section {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 20px;
}

.bar-chart {
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
  width: 100%;
  height: 200px;
  padding: 0 20px;
  margin-bottom: 30px;

  .bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40px;
    background: linear-gradient(to top, #409eff, #66b1ff);
    border-radius: 4px;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
    }

    .bar-value {
      position: absolute;
      top: -25px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      font-weight: bold;
      color: #303133;
    }

    .bar-label {
      position: absolute;
      bottom: -25px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      color: #606266;
      text-align: center;
      width: 80px;
      white-space: nowrap;
    }
  }
}
</style>